export interface TaskTemplateInterface {
  id?: number;
  taskName?: string;
  templateName?: string;
  defaultHours?: number;
  defaultNotes?: string;
  defaultSummary?: string;
  defaultDays?: number;
  reserved?: boolean;
  defaultDueDate?: Date;
  entityType?: string;
}

export class TaskTemplate implements TaskTemplate {
  public id?: number;
  public taskName?: string;
  public templateName?: string;
  public defaultHours?: number;
  public defaultNotes?: string;
  public defaultSummary?: string;
  public defaultDays?: number;
  public reserved?: boolean;
  public defaultDueDate?: Date;
  public entityType?: string;

  constructor({
    id = undefined,
    taskName = undefined,
    templateName = undefined,
    defaultHours = undefined,
    defaultNotes = undefined,
    defaultSummary = undefined,
    defaultDays = undefined,
    reserved = undefined,
    defaultDueDate = undefined,
    entityType = undefined,
  }: TaskTemplate) {
    this.id = id;
    this.taskName = taskName;
    this.templateName = templateName;
    this.defaultHours = defaultHours;
    this.defaultNotes = defaultNotes;
    this.defaultSummary = defaultSummary;
    this.defaultDays = defaultDays;
    this.reserved = reserved;
    this.defaultDueDate = defaultDueDate;
    this.entityType = entityType;
  }
}
